import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import Login from '@/components/Login'
import Logout from '@/components/Logout'
import Admin from '@/components/admin/Admin'
import Dashboard from '@/components/admin/Dashboard'
import User from '@/components/admin/user/User'
import UserList from '@/components/admin/user/UserList'
import UserCreate from '@/components/admin/user/UserCreate'
import UserEdit from '@/components/admin/user/UserEdit'
import Acl from '@/components/admin/acl/Acl'
import AclList from '@/components/admin/acl/AclList'
import AclCreate from '@/components/admin/acl/AclCreate'
import AclEdit from '@/components/admin/acl/AclEdit'
import Menu from '@/components/admin/menu/Menu'
import MenuList from '@/components/admin/menu/MenuList'
import MenuCreate from '@/components/admin/menu/MenuCreate'
import MenuEdit from '@/components/admin/menu/MenuEdit'
import Module from '@/components/admin/module/Module'
import ModuleList from '@/components/admin/module/ModuleList'
import ModuleCreate from '@/components/admin/module/ModuleCreate'
import ModuleUpdateMiddleware from '@/components/admin/module/ModuleUpdateMiddleware'
import ModuleUpdateEntity from '@/components/admin/module/ModuleUpdateEntity'
import ModuleUpdatePrefix from '@/components/admin/module/ModuleUpdatePrefix'
import ModuleUpdateValidation from '@/components/admin/module/ModuleUpdateValidation'
import ModuleUpdateResource from '@/components/admin/module/ModuleUpdateResource'
import ModuleUpdateInputs from '@/components/admin/module/ModuleUpdateInputs'
import Custom from '@/components/admin/custom/Custom'
import CustomListModule from '@/components/admin/custom/CustomListModule'
import CustomEditModule from '@/components/admin/custom/CustomEditModule'
import CustomCreateModule from '@/components/admin/custom/CustomCreateModule'
import Translation from '@/components/admin/translation/Translation'
import TranslationList from '@/components/admin/translation/TranslationList'
import Profile from '@/components/admin/profile/Profile'
import NotFound from '@/components/admin/NotFound'

import Book from '@/components/admin/book/Book'
import BookList from '@/components/admin/book/BookList'
import BookCreate from '@/components/admin/book/BookCreate'
import BookEdit from '@/components/admin/book/BookEdit'

import Category from '@/components/admin/category/Category'
import CategoryList from '@/components/admin/category/CategoryList'
import CategoryCreate from '@/components/admin/category/CategoryCreate'
import CategoryEdit from '@/components/admin/category/CategoryEdit'

import Order from '@/components/admin/order/Order'
import OrderList from '@/components/admin/order/OrderList'
import OrderCreate from '@/components/admin/order/OrderCreate'
import OrderEdit from '@/components/admin/order/OrderEdit'

import Shipment from '@/components/admin/shipment/Shipment'
import ShipmentList from '@/components/admin/shipment/ShipmentList'
import ShipmentCreate from '@/components/admin/shipment/ShipmentCreate'
import ShipmentEdit from '@/components/admin/shipment/ShipmentEdit'

import Author from '@/components/admin/author/Author'
import AuthorList from '@/components/admin/author/AuthorList'
import AuthorCreate from '@/components/admin/author/AuthorCreate'
import AuthorEdit from '@/components/admin/author/AuthorEdit'

import Page from '@/components/admin/page/Page'
import PageList from '@/components/admin/page/PageList'
import PageCreate from '@/components/admin/page/PageCreate'
import PageEdit from '@/components/admin/page/PageEdit'

import VueI18n from 'vue-i18n'

Vue.use(VueRouter)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: store.state.loading.language, // set locale
  fallbackLocale: 'hu',
  silentTranslationWarn: true,
  messages: {
    en: store.state.loading.languages.en,
    hu: store.state.loading.languages.hu
  } // set locale messages
})

Vue.prototype.$translate = i18n

let router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/admin',
      meta: {
        requiresAuth: true,
        title: 'Admin'
      }
    },
    {
      path: '*',
      redirect: '/admin',
      meta: {
        requiresAuth: true,
        title: i18n.t('Page Not Found')
      }
    },
    {
      path: '/404',
      component: NotFound,
      meta: {
        title: i18n.t('Page Not Found')
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: i18n.t('Login Page')
      }
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/admin',
      component: Admin,
      meta: {
        requiresAuth: true,
        title: i18n.t('Admin')
      },
      children: [
        {
          path: '',
          component: Dashboard,
          meta: {
            title: i18n.t('Dashboard')
          }
        },
        {
          path: '404',
          component: NotFound,
          meta: {
            title: i18n.t('Page Not Found')
          }
        },
        {
          path: 'profile',
          component: Profile,
          meta: {
            title: i18n.t('Profile')
          }
        },
        {
          path: 'user',
          component: User,
          meta: {
            title: i18n.t('Users')
          },
          children: [
            {
              path: 'index',
              name: 'UserList',
              component: UserList
            },
            {
              path: 'create',
              name: 'UserCreate',
              component: UserCreate
            },
            {
              path: 'edit/:id',
              name: 'UserEdit',
              component: UserEdit
            }
          ]
        },
        {
          path: 'translation',
          component: Translation,
          meta: {
            title: i18n.t('Translations')
          },
          children: [
            {
              path: 'index',
              name: 'TranslationList',
              component: TranslationList
            }
          ]
        },
        {
          path: 'acl',
          component: Acl,
          meta: {
            title: i18n.t('Roles')
          },
          children: [
            {
              path: 'index',
              name: 'AclList',
              component: AclList
            },
            {
              path: 'create',
              name: 'AclCreate',
              component: AclCreate
            },
            {
              path: 'edit/:id',
              name: 'AclEdit',
              component: AclEdit
            }
          ]
        },
        {
          path: 'menu',
          component: Menu,
          meta: {
            title: i18n.t('Menus')
          },
          children: [
            {
              path: 'index',
              name: 'MenuList',
              component: MenuList
            },
            {
              path: 'create',
              name: 'MenuCreate',
              component: MenuCreate
            },
            {
              path: 'edit/:id',
              name: 'MenuEdit',
              component: MenuEdit
            }
          ]
        },
        /* ----------------------------------------- */
        {
          path: 'authors',
          component: Author,
          meta: {
            title: i18n.t('Authors')
          },
          children: [
            {
              path: 'index',
              name: 'AuthorList',
              component: AuthorList
            },
            {
              path: 'create',
              name: 'AuthorCreate',
              component: AuthorCreate
            },
            {
              path: 'edit/:id',
              name: 'AuthorEdit',
              component: AuthorEdit
            }
          ]
        },
        {
          path: 'books',
          component: Book,
          meta: {
            title: i18n.t('Books')
          },
          children: [
            {
              path: 'index',
              name: 'BookList',
              component: BookList
            },
            {
              path: 'create',
              name: 'BookCreate',
              component: BookCreate
            },
            {
              path: 'edit/:id',
              name: 'BookEdit',
              component: BookEdit
            }
          ]
        },
        {
          path: 'pages',
          component: Page,
          meta: {
            title: i18n.t('Pages')
          },
          children: [
            {
              path: 'index',
              name: 'PageList',
              component: PageList
            },
            {
              path: 'create',
              name: 'PageCreate',
              component: PageCreate
            },
            {
              path: 'edit/:id',
              name: 'PageEdit',
              component: PageEdit
            }
          ]
        },
        {
          path: 'shipments',
          component: Shipment,
          meta: {
            title: i18n.t('Shipments')
          },
          children: [
            {
              path: 'index',
              name: 'ShipmentList',
              component: ShipmentList
            },
            {
              path: 'create',
              name: 'ShipmentCreate',
              component: ShipmentCreate
            },
            {
              path: 'edit/:id',
              name: 'ShipmentEdit',
              component: ShipmentEdit
            }
          ]
        },
        {
          path: 'categories',
          component: Category,
          meta: {
            title: i18n.t('Categorys')
          },
          children: [
            {
              path: 'index',
              name: 'CategoryList',
              component: CategoryList
            },
            {
              path: 'create',
              name: 'CategoryCreate',
              component: CategoryCreate
            },
            {
              path: 'edit/:id',
              name: 'CategoryEdit',
              component: CategoryEdit
            }
          ]
        },
        {
          path: 'orders',
          component: Order,
          meta: {
            title: i18n.t('Orders')
          },
          children: [
            {
              path: 'index',
              name: 'OrderList',
              component: OrderList
            },
            {
              path: 'create',
              name: 'OrderCreate',
              component: OrderCreate
            },
            {
              path: 'edit/:id',
              name: 'OrderEdit',
              component: OrderEdit
            }
          ]
        },
        /* ----------------------------------------- */
        {
          path: 'modules',
          component: Module,
          meta: {
            title: i18n.t('Modules')
          },
          children: [
            {
              path: 'index',
              name: 'ModuleList',
              component: ModuleList
            },
            {
              path: 'create',
              name: 'ModuleCreate',
              component: ModuleCreate
            },
            {
              path: 'update-middleware/:id',
              name: 'ModuleUpdateMiddleware',
              component: ModuleUpdateMiddleware
            },
            {
              path: 'update-entity/:id',
              name: 'ModuleUpdateEntity',
              component: ModuleUpdateEntity
            },
            {
              path: 'update-prefix/:id',
              name: 'ModuleUpdatePrefix',
              component: ModuleUpdatePrefix
            },
            {
              path: 'update-validation/:id',
              name: 'ModuleUpdateValidation',
              component: ModuleUpdateValidation
            },
            {
              path: 'update-resource/:id',
              name: 'ModuleUpdateResource',
              component: ModuleUpdateResource
            },
            {
              path: 'update-inputs/:id',
              name: 'ModuleUpdateInputs',
              component: ModuleUpdateInputs
            }
          ]
        },
        {
          path: ':module',
          component: Custom,
          meta: {
            title: 'Custom'
          },
          children: [
            {
              path: 'index',
              component: CustomListModule
            },
            {
              path: 'create',
              component: CustomCreateModule
            },
            {
              path: 'edit/:id',
              component: CustomEditModule
            }
          ]
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (store.state.loading.unsaved === true) {
    let r = confirm(i18n.t('Önnek nem mentett változásai vannak! Biztosan kilép az oldalról?'))
    if (r === true) {
      store.commit('loading/changeUnsaved', false)
    } else {
      return false
    }
  }

  store.commit('loading/change', true)

  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title + ' | ' + process.env.APP_NAME

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  // Skip rendering meta tags if there are none.
  if (nearestWithMeta) {
    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key])
      })

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '')

      return tag
    })
    // Add the meta tags to the document head.
      .forEach(tag => document.head.appendChild(tag))
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (localStorage.getItem('token') === null) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js